export const liveChatFeaturesStyles = `
/* ========================================
   ATTACHMENTS
   ======================================== */
.liveChat-compose-attachments-preview {
  display: none;
  flex-wrap: wrap;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-4);
  border-top: 1px solid var(--msg-border);
  background: var(--msg-bg);
}

.liveChat-attachment-preview {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.liveChat-attachment-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.liveChat-attachment-file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-neutral-100);
  color: var(--color-text-secondary);
}

.liveChat-attachment-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: var(--radius-full);
  color: var(--color-white);
  font-size: var(--font-size-xs);
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background var(--transition-base);
}

.liveChat-attachment-remove:hover {
  background: var(--color-error);
}

/* ========================================
   EMAIL OVERLAY
   ======================================== */
.liveChat-email-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: none;
  align-items: flex-end;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

.liveChat-email-card {
  width: 100%;
  animation: liveChat-slide-up 0.25s ease;
}

.liveChat-email-actions {
  display: flex;
  gap: var(--spacing-2);
  margin-top: var(--spacing-1);
}

/* ========================================
   EMPTY STATE
   ======================================== */
.liveChat-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--spacing-10);
}

.liveChat-empty-state-icon {
  color: var(--msg-text-tertiary);
  margin-bottom: var(--spacing-4);
}

.liveChat-empty-state h3 {
  margin: 0 0 var(--spacing-2);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.liveChat-empty-state p {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
}

/* ========================================
   ANIMATIONS
   ======================================== */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes liveChat-typing-bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

@keyframes liveChat-slide-up {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes liveChat-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ========================================
   RESPONSIVE
   ======================================== */
@media (max-width: 480px) {
  .liveChat-prechat-overlay {
    padding: var(--spacing-4);
  }
  .liveChat-prechat-card {
    max-width: 100%;
  }
}
`;
